import actionCreatorFactory from 'typescript-fsa';
import { reducerWithInitialState } from 'typescript-fsa-reducers';
//const authentication = require('react-azure-adb2c').default;
//import { Dispatch } from 'redux';


import { call, put, takeEvery, select } from 'redux-saga/effects';
// import * as RentContractMoniesApi from '../Api/RentContractMoniesApi.ts_';
// import * as RentContractAccountingApi from '../Api/RentContractAccountingApi.ts_';
import * as minories_api from '../Api/minories_api';
import * as ky_sqdata_api from '../Api/ky_sqdata_api';
import moment from 'moment'
// import * as UsersApi from './Api/UsersApi';
// import * as RentAgentsApi from './Api/RentAgentsApi';
// import * as Kyousai from '../../Kyousai/Saga/Kyousai';
///types


//export interface HogeState {
//    responselist: string[];
//    responseedit: number;
//}
export interface State {
    // rent_contract_monies:any;
    minories: any;
    minori_basedate: any;
    minori_loading: boolean;
    so_dd1: any;
    // owner_remitt: any;ance_check_logs_list: any;
    // owner_remittance_check_logs_sum: any;
    // so_ymd_list: any;

    // so_ymd_list_sum: any;
    // remittancelogcheck_search_form: any;
    // search_diff: any;
    // search_contract_date_start: any;
    // search_contract_date_end: any;
    // search_tatemono_name: any;
    // parking_check_loading: number;
    // net_check_loading: number;

    // energization_check_loading: number;

    // electronics_check_loading: number;
    // wifi_check_loading: number;
    // search_loading: boolean;
    // owner_tel_check_loading: number;
}
const initialState: State = {

    // rent_contract_monies: [],
    minories: [],
    minori_basedate: null,
    minori_loading: false,
    so_dd1: [],
    // owner_remittance_check_logs_list: [],
    // so_ymd_list: [],
    // so_ymd_list_sum: 0,
    // owner_remittance_check_logs_sum: 0,
    // search_diff: false,
    // remittancelogcheck_search_form: {
    //     so_ymd: '2020/6/20',
    //     // search_contract_date_start: null,
    //     // search_contract_date_end: null,
    //     // search_tatemono_name: null,
    //     // search_completed: false,
    // },
    // search_contract_date_start: null,
    // search_contract_date_end: null,
    // search_tatemono_name: "",

    // parking_check_loading: 0,
    // net_check_loading: 0,

    // energization_check_loading: 0,

    // electronics_check_loading: 0,
    // wifi_check_loading: 0,
    // search_loading: false,
    // owner_tel_check_loading: 0,

    // users: [],
    // rentAgents: [],
    // rentMReasons: [],



}



///action 
const actionCreator = actionCreatorFactory();

// export const get_rent_contract_monies = actionCreator<{rent_contract_id:number}>('GET_RENT_CONTRACT_MONIES');
// export const get_rent_contract_monies_success = actionCreator("GET_RENT_CONTRACT_MONIES_SUCCESS");
// export const get_rent_contract_monies_failure = actionCreator("GET_RENT_CONTRACT_MONIES_FAILURE");

// export const get_rent_contract_accounting = actionCreator("GET_RENT_CONTRACT_ACCOUNTING");


export const get_minories = actionCreator<any>('GET_MINORIES');
export const change_minories = actionCreator("CHANGE_MINORIES");
export const change_minori_basedate = actionCreator("CHANGE_MINORI_BASEDATE");


export const update_minori_kojo = actionCreator("UPDATE_MINORI_KOJO");

export const change_minori_loading = actionCreator<boolean>("CHANGE_MINORI_LOADING");

export const get_so_dd1 = actionCreator<any>('GET_SO_DD1');
export const change_so_dd1 = actionCreator("CHANGE_SO_DD1");



// export const change_owner_remittance_check_logs_list = actionCreator("CHANGE_OWNER_REMITTANCE_CHECK_LOGS_LIST");


// export const get_so_ymd_list = actionCreator<any>("GET_SO_YMD_LIST");
// export const change_so_ymd_list = actionCreator<any>("CHANGE_SO_YMD_LIST");

// export const change_owner_remittance_check_logs_sum = actionCreator<number>("CHANGE_OWNER_REMITTANCE_CHECK_LOGS_SUM");
// export const change_so_ymd_list_sum = actionCreator<number>("CHANGE_SO_YMD_LIST_SUM");

// export const change_search_diff = actionCreator<boolean>("CHANGE_SEARCH_DIFF");


// export const parking_checked = actionCreator("PARKING_CHECKED");
// export const change_parking_check_loading = actionCreator<number>("CHANGE_PARKING_CHECK_LOADING");

// export const net_checked = actionCreator("NET_CHECKED");
// export const change_net_check_loading = actionCreator<number>("CHANGE_NET_CHECK_LOADING");

// export const energization_checked = actionCreator("ENERGIZATION_CHECKED");
// export const change_energization_check_loading = actionCreator<number>("CHANGE_ENERGIZATION_CHECK_LOADING");

// export const electronics_checked = actionCreator("ELECTRONICS_CHECKED");
// export const change_electronics_check_loading = actionCreator<number>("CHANGE_ELECTRONICS_CHECK_LOADING");

// export const wifi_checked = actionCreator("WIFI_CHECKED");
// export const change_wifi_check_loading = actionCreator<number>("CHANGE_WIFI_CHECK_LOADING");

// export const completed_checked = actionCreator("COMPLETED_CHECKED");


// export const all_selected = actionCreator("ALL_SELECTED");

// export const change_search_form = actionCreator("CHANGE_SEARCH_FORM");

// export const check_completed = actionCreator("CHECK_COMPLETED");
// export const change_search_loading = actionCreator<boolean>("CHANGE_SEARCH_LOADING");

// export const check_completed_cancel = actionCreator("CHECK_COMPLETED_CANCEL");


// export const owner_tel_checked = actionCreator("OWNER_TEL_CHECKED");
// export const change_owner_tel_check_loading = actionCreator<number>("CHANGE_OWNER_TEL_CHECK_LOADING");


// export const change_remittancelogcheck_search_form = actionCreator<any>("CHANGE_REMITTANCELOGCHECK_SEARCH_FROM");
// export const change_search_contract_date_start = actionCreator<string>("CHANGE_SEARCH_CONTRACT_DATE_START");
// export const change_search_contract_date_end = actionCreator<string>("CHANGE_SEARCH_CONTRACT_DATE_END");


// export const bind_kyousai_contract = actionCreator('BIND_KYOUSAI_CONTRACT');

// export const change_search_tatemono_name = actionCreator<string>("CHANGE_SEARCH_TATEMONO_NAME");




// export const get_banks_failure = actionCreator("GET_BANKS_FAILURE");

// export const getUsers = actionCreator('USERS_REQUEST');
// export const getUsersSuccess = actionCreator("USERS_SUCCESS");
// export const getUsersFailure = actionCreator("USERS_FAILURE");

// export const getRentAgents = actionCreator('RENT_AGENTS_REQUEST');
// export const getRentAgentsSuccess = actionCreator("RENT_AGENTS_SUCCESS");
// export const getRentAgentsFailure = actionCreator("RENT_AGENTS_FAILURE");


// export const getRentMReasons = actionCreator('RENT_M_REASONS_REQUEST');
// export const getRentMReasonsSuccess = actionCreator("RENT_M_REASONS_SUCCESS");
// export const getRentMReasonsFailure = actionCreator("RENT_M_REASONS_FAILURE");


export const minoriReducer = reducerWithInitialState(initialState)
    .case(change_minories, (state, payload) => ({ ...state, minories: payload }))
    .case(change_minori_basedate, (state, payload) => ({ ...state, minori_basedate: payload }))
    .case(change_minori_loading, (state, payload) => ({ ...state, minori_loading: payload }))
    .case(change_so_dd1, (state, payload) => ({ ...state, so_dd1: payload }))


// .case(change_so_ymd_list, (state, payload) => ({ ...state, so_ymd_list: payload }))
// .case(change_remittancelogcheck_search_form, (state, payload) => ({ ...state, remittancelogcheck_search_form: payload }))

// .case(change_owner_remittance_check_logs_sum, (state, payload) => ({ ...state, owner_remittance_check_logs_sum: payload }))
// .case(change_so_ymd_list_sum, (state, payload) => ({ ...state, so_ymd_list_sum: payload }))
// .case(change_search_diff, (state, payload) => ({ ...state, search_diff: payload }))

// .case(change_owner_remittance_check_logs_list, (state, payload) => ({ ...state, owner_remittance_check_logs_list: payload }))


// .case(change_net_check_loading, (state, payload) => ({ ...state, net_check_loading: payload }))
// .case(change_energization_check_loading, (state, payload) => ({ ...state, energization_check_loading: payload }))
// .case(change_wifi_check_loading, (state, payload) => ({ ...state, wifi_check_loading: payload }))
// .case(change_electronics_check_loading, (state, payload) => ({ ...state, electronics_check_loading: payload }))
// .case(change_search_form, (state, payload) => ({ ...state, search_form: payload }))
// .case(change_search_loading, (state, payload) => ({ ...state, search_loading: payload }))

// .case(change_owner_tel_check_loading, (state, payload) => ({ ...state, owner_tel_check_loading: payload }))


// .case(change_search_contract_date_start, (state, payload) => ({ ...state, search_contract_date_start: payload }))
// .case(change_search_contract_date_end, (state, payload) => ({ ...state, search_contract_date_end: payload }))
// .case(change_search_tatemono_name, (state, payload) => ({ ...state, search_tatemono_name: payload }))



//.case(getRentMMedeasFailure, (state, payload) => ({ ...state, rentMMedeas: payload }))
// .case(getUsersSuccess, (state, payload) => ({ ...state, users: payload }))
// .case(getUsersFailure, (state, payload) => ({ ...state, users: payload }))
// .case(getRentAgentsSuccess, (state, payload) => ({ ...state, rentAgents: payload }))
// .case(getRentAgentsFailure, (state, payload) => ({ ...state, rentAgents: payload }))
// .case(getRentMReasonsSuccess, (state, payload) => ({ ...state, rentMReasons: payload }))
// .case(getRentMReasonsFailure, (state, payload) => ({ ...state, rentMReasons: payload }));







// 「LOGIN_REQUEST」アクションが呼ばれるのを待つ呼ばれたhandleRequestを実行
export const minoriSaga = [
    //     takeEvery('GET_RENT_CONTRACT_MONIES', handleRequestMoney),
    // takeEvery('GET_RENT_CONTRACT_ACCOUNTING', handle_get_rent_contract_accounting),
    takeEvery('GET_MINORIES', handle_get_minories),
    takeEvery('UPDATE_MINORI_KOJO', handle_update_minori_kojo),
    takeEvery('GET_SO_DD1', handle_get_so_dd1),


    // takeEvery('NET_CHECKED', handle_net_checked),

    // takeEvery('ENERGIZATION_CHECKED', handle_energization_checked),

    // takeEvery('ELECTRONICS_CHECKED', handle_electronics_checked),
    // takeEvery('WIFI_CHECKED', handle_wifi_checked),
    // // takeEvery('BIND_KYOUSAI_CONTRACT', handle_bind_kyousai_contract),

    // takeEvery('COMPLETED_CHECKED', handle_completed_checked),

    // takeEvery('ALL_SELECTED', handle_all_selected),

    // takeEvery('CHECK_COMPLETED', handle_check_completed),

    // takeEvery('CHECK_COMPLETED_CANCEL', handle_check_completed_cancel),

    // takeEvery('OWNER_TEL_CHECKED', handle_owner_tel_checked),

    // takeEvery('USERS_REQUEST', handleUsersRequest),
    // takeEvery('RENT_AGENTS_REQUEST', handleRentAgentsRequest),
    // takeEvery('RENT_M_REASONS_REQUEST', handleRentMReasonsRequest),
];
// export default masterSaga;



function* handle_get_minories(action: any) {
    const state = yield select();

    // let search_form = state.ContractCheck.search_form
    // yield put(change_search_loading(true))

    // let search_id = state.kyousaiReducer.search_id
    let so_dd1 = state.Minori.so_dd1
    if (state.Minori.so_dd1.length === 0) {
        const { payloads, errors } = yield call(minories_api.so_dd1, action.payload);

        // サーバーからのレスポンスデータによる分岐処理
        if (payloads && !errors) {
            yield put(change_so_dd1(payloads));
            so_dd1 = payloads
        }

    }

    const { payload, error } = yield call(minories_api.list, action.payload);

    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
        console.log(payload)
        let minories = payload.map(function (value: any) {
            value.so_ymd = null
            value.so_dd1 = null
            return value
        })


        minories = minories.map(function (value: any) {

            so_dd1.map(function (sodd: any) {
                if (parseInt(sodd.bk_no) === parseInt(value.bk_no)) {
                    value.so_dd1 = sodd.so_dd1

                }

            })

            return value
        })





        minories = minories.map(function (value: any) {
            value.contract_date = value.contract_date ? String(moment(value.contract_date).utc().format("YYYY/MM/DD")) : ""
            value.m_omakase_kakumei_at = value.m_omakase_kakumei_at ? String(moment(value.m_omakase_kakumei_at).utc().format("YYYY/MM/DD HH:mm:ss")) : ""
            value.m_omakase_kakumei_so_ymd = value.m_omakase_kakumei_so_ymd ? String(moment(value.m_omakase_kakumei_so_ymd).utc().format("YYYY/MM/DD")) : ""



            return value
        })








        yield put(change_minories(minories));




    } else {
        alert(error)
        //    // 失敗時アクション呼び出し
        //    yield put(loginFailure(payload));
    }

}



function* handle_update_minori_kojo(action: any) {
    const state = yield select();

    yield put(change_minori_loading(true))

    const { payload, error } = yield call(ky_sqdata_api.kakumeiinsert, state.Minori.minories);

    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
        // 成功時アクション呼び出し
        console.log(payload)
        // alert(payload)
        yield put(get_minories(payload));

        yield put(change_minori_loading(false))

    } else {
        alert(error)
        //    // 失敗時アクション呼び出し
        //    yield put(loginFailure(payload));
    }

}



function* handle_get_so_dd1(action: any) {
    const state = yield select();


    const { payload, error } = yield call(minories_api.so_dd1, action.payload);

    // サーバーからのレスポンスデータによる分岐処理
    if (payload && !error) {
        // 成功時アクション呼び出し
        console.log(payload)
        // alert(payload)
        yield put(change_so_dd1(payload));

        alert(state.Minori.minories.length)
        let minories = state.Minori.minories.map(function (value: any) {
            alert(payload.length)
            payload.map(function (sodd: any) {
                if (parseInt(sodd.bk_no) === parseInt(value.bk_no)) {
                    value.so_dd1 = sodd.so_dd1
                    alert()
                }
            })

            return value
        })
        yield put(change_minories(minories));

    } else {
        alert(error)
        //    // 失敗時アクション呼び出し
        //    yield put(loginFailure(payload));
    }

}

// function* handle_get_so_ymd_list(action: any) {
//     const { payload, error } = yield call(sh_furi_api.soymdlist, action.payload);
//     // サーバーからのレスポンスデータによる分岐処理
//     if (payload && !error) {
//         //
//         yield put(change_so_ymd_list(payload));


//     } else {
//         alert(error)
//         //    // 失敗時アクション呼び出し
//         //    yield put(loginFailure(payload));
//     }

// }


// function* handle_net_checked(action: any) {
//     const state = yield select();

//     yield put(change_net_check_loading(action.payload));
//     let rent_contracts_check_list = state.ContractCheck.rent_contracts_check_list
//     let s = rent_contracts_check_list.map(function (value: any) {
//         return { ...value, value }
//     })
//     yield put(change_rent_contracts_check_list(s));

//     const { payload, error } = yield call(rent_contracts_check_api.net, { rent_contract_id: action.payload });

//     // サーバーからのレスポンスデータによる分岐処理
//     if (payload && !error) {
//         // 成功時アクション呼び出し

//         let w = rent_contracts_check_list.map(function (value: any) {

//             if (value.id === action.payload) {
//                 value.office_check_net_user_name = payload.office_check_net_user_name
//                 value.office_check_net_at = payload.office_check_net_at
//                 value.office_check_net_user_name = payload.office_check_net_user_name
//                 return {
//                     ...value, value
//                 }
//             } else {
//                 return value
//             }
//         })
//         yield put(change_net_check_loading(0));
//         yield put(change_rent_contracts_check_list(w));


//     } else {
//         alert(error)
//         //    // 失敗時アクション呼び出し
//         //    yield put(loginFailure(payload));
//     }

// }


// function* handle_energization_checked(action: any) {
//     const state = yield select();

//     yield put(change_energization_check_loading(action.payload));
//     let rent_contracts_check_list = state.ContractCheck.rent_contracts_check_list
//     let s = rent_contracts_check_list.map(function (value: any) {
//         return { ...value, value }
//     })
//     yield put(change_rent_contracts_check_list(s));

//     const { payload, error } = yield call(rent_contracts_check_api.energization, { rent_contract_id: action.payload });

//     // サーバーからのレスポンスデータによる分岐処理
//     if (payload && !error) {
//         // 成功時アクション呼び出し

//         let w = rent_contracts_check_list.map(function (value: any) {

//             if (value.id === action.payload) {
//                 value.office_check_energization_user_name = payload.office_check_energization_user_name
//                 value.office_check_energization_at = payload.office_check_energization_at
//                 value.office_check_energization_user_name = payload.office_check_energization_user_name
//                 return {
//                     ...value, value
//                 }
//             } else {
//                 return value
//             }
//         })
//         yield put(change_energization_check_loading(0));
//         yield put(change_rent_contracts_check_list(w));


//     } else {
//         alert(error)
//         //    // 失敗時アクション呼び出し
//         //    yield put(loginFailure(payload));
//     }

// }


// function* handle_electronics_checked(action: any) {
//     const state = yield select();

//     yield put(change_electronics_check_loading(action.payload));
//     let rent_contracts_check_list = state.ContractCheck.rent_contracts_check_list
//     let s = rent_contracts_check_list.map(function (value: any) {
//         return { ...value, value }
//     })
//     yield put(change_rent_contracts_check_list(s));

//     const { payload, error } = yield call(rent_contracts_check_api.electronics, { rent_contract_id: action.payload });

//     // サーバーからのレスポンスデータによる分岐処理
//     if (payload && !error) {
//         // 成功時アクション呼び出し

//         let w = rent_contracts_check_list.map(function (value: any) {

//             if (value.id === action.payload) {
//                 value.office_check_electronics_user_name = payload.office_check_electronics_user_name
//                 value.office_check_electronics_at = payload.office_check_electronics_at
//                 value.office_check_electronics_user_name = payload.office_check_electronics_user_name
//                 return {
//                     ...value, value
//                 }
//             } else {
//                 return value
//             }
//         })
//         yield put(change_electronics_check_loading(0));
//         yield put(change_rent_contracts_check_list(w));


//     } else {
//         alert(error)
//         //    // 失敗時アクション呼び出し
//         //    yield put(loginFailure(payload));
//     }

// }


// function* handle_wifi_checked(action: any) {
//     const state = yield select();

//     yield put(change_wifi_check_loading(action.payload));
//     let rent_contracts_check_list = state.ContractCheck.rent_contracts_check_list
//     let s = rent_contracts_check_list.map(function (value: any) {
//         return { ...value, value }
//     })
//     yield put(change_rent_contracts_check_list(s));

//     const { payload, error } = yield call(rent_contracts_check_api.wifi, { rent_contract_id: action.payload });

//     // サーバーからのレスポンスデータによる分岐処理
//     if (payload && !error) {
//         // 成功時アクション呼び出し

//         let w = rent_contracts_check_list.map(function (value: any) {

//             if (value.id === action.payload) {
//                 value.office_check_wifi_user_name = payload.office_check_wifi_user_name
//                 value.office_check_wifi_at = payload.office_check_wifi_at
//                 value.office_check_wifi_user_name = payload.office_check_wifi_user_name
//                 return {
//                     ...value, value
//                 }
//             } else {
//                 return value
//             }
//         })
//         yield put(change_wifi_check_loading(0));
//         yield put(change_rent_contracts_check_list(w));


//     } else {
//         alert(error)
//         //    // 失敗時アクション呼び出し
//         //    yield put(loginFailure(payload));
//     }

// }

// function* handle_owner_tel_checked(action: any) {
//     const state = yield select();

//     yield put(change_owner_tel_check_loading(action.payload));
//     let rent_contracts_check_list = state.ContractCheck.rent_contracts_check_list
//     let s = rent_contracts_check_list.map(function (value: any) {
//         return { ...value, value }
//     })
//     yield put(change_rent_contracts_check_list(s));

//     const { payload, error } = yield call(rent_contracts_check_api.owner_tel, { rent_contract_id: action.payload });

//     // サーバーからのレスポンスデータによる分岐処理
//     if (payload && !error) {
//         // 成功時アクション呼び出し

//         let w = rent_contracts_check_list.map(function (value: any) {

//             if (value.id === action.payload) {
//                 value.office_check_owner_tel_user_name = payload.office_check_owner_tel_user_name
//                 value.office_check_owner_tel_at = payload.office_check_owner_tel_at
//                 value.office_check_owner_tel_user_name = payload.office_check_owner_tel_user_name
//                 return {
//                     ...value, value
//                 }
//             } else {
//                 return value
//             }
//         })
//         yield put(change_owner_tel_check_loading(0));
//         yield put(change_rent_contracts_check_list(w));


//     } else {
//         alert(error)
//         //    // 失敗時アクション呼び出し
//         //    yield put(loginFailure(payload));
//     }

// }



// function* handle_completed_checked(action: any) {
//     const state = yield select();


//     let rent_contracts_check_list = state.ContractCheck.rent_contracts_check_list
//     let s = rent_contracts_check_list.map(function (value: any) {
//         if (value.id === action.payload) {
//             value.office_check_completed = !value.office_check_completed
//             return { ...value, value }
//         } else {
//             return value
//         }
//     })
//     yield put(change_rent_contracts_check_list(s));



// }


// function* handle_all_selected(action: any) {
//     const state = yield select();


//     let rent_contracts_check_list = state.ContractCheck.rent_contracts_check_list
//     let s = rent_contracts_check_list.map(function (value: any) {

//         value.office_check_completed = action.payload
//         return { ...value, value }

//     })
//     yield put(change_rent_contracts_check_list(s));



// }



// function* handle_check_completed(action: any) {
//     const state = yield select();

//     yield put(change_search_loading(true))
//     let rent_contracts_check_list = state.ContractCheck.rent_contracts_check_list.filter((a: any) => a.office_check_completed === true)
//     // let s = rent_contracts_check_list.map(function (value: any) {
//     //     return { ...value, value }
//     // })
//     // yield put(change_rent_contracts_check_list(s));

//     const { payload, error } = yield call(rent_contracts_check_api.check_completed, rent_contracts_check_list);

//     // サーバーからのレスポンスデータによる分岐処理
//     if (payload && !error) {
//         // 成功時アクション呼び出し


//         yield put(get_rent_contracts_check_list(payload));


//     } else {
//         alert(error)
//         //    // 失敗時アクション呼び出し
//         //    yield put(loginFailure(payload));
//     }

// }



